module.exports = __webpack_public_path__ + "img/kleisma4-m@2.67065b81.jpg";